/* eslint-disable */
import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';

import Layout from './components/Layout/Layout';
import Classes from './App.css';
import MConfig from './moramma-config.json';

class App extends Component {
  render() {
    if(MConfig['BASE_API'] === "https://beta.moramma.com") {
      return(
        <BrowserRouter>
          <p className={Classes.SectionOpenPbScreenBeta}><i class="fas fa-info-circle"></i> {` Moramma™ dev-rc-${MConfig['VERSION']}`}</p>
          <Layout />
        </BrowserRouter>  
      )
    } else {
      return(
        <BrowserRouter>
         <p className={Classes.SectionOpenPbScreenBeta}><i class="fas fa-info-circle"></i> {` Moramma™ beta-${MConfig['VERSION']}`}</p>
          <Layout />
        </BrowserRouter>  
      ) 
    }
  }
}

export default App;
